/**
 * Interwork Marketing — O'zbek (default)
 */
import type { Dictionary } from "../types";

export const uz: Dictionary = {
  common: {
    loading: "Yuklanmoqda...",
    error: "Xatolik yuz berdi",
    retry: "Qayta urinish",
    save: "Saqlash",
    cancel: "Bekor qilish",
    delete: "O'chirish",
    edit: "Tahrirlash",
    close: "Yopish",
    confirm: "Tasdiqlash",
    search: "Qidirish",
    filter: "Filtr",
    filters: "Filtrlar",
    export: "CSV eksport",
    refresh: "Yangilash",
    back: "Orqaga",
    next: "Keyingi",
    previous: "Avvalgi",
    submit: "Yuborish",
    actions: "Amallar",
    yes: "Ha",
    no: "Yo'q",
    empty: "Ma'lumot yo'q",
    all: "Hammasi",
    active: "Faol",
    paused: "To'xtatilgan",
    archived: "Arxiv",
    total: "Jami",
    today: "Bugun",
    yesterday: "Kecha",
    week: "Hafta",
    month: "Oy",
    last7: "So'nggi 7 kun",
    last30: "So'nggi 30 kun",
    last90: "So'nggi 90 kun",
    overall: "Umumiy",
    settings: "Sozlamalar",
    logout: "Chiqish",
    language: "Til",
    languageUz: "O'zbek",
    languageRu: "Русский",
    languageEn: "English",
    openMenu: "Menyuni ochish",
    closeMenu: "Menyuni yopish",
    popular: "Mashhur",
    more: "Yana",
    noData: "Ma'lumot yo'q",
    sync: "Sinxronlash",
    syncStarted: "Sinxronlash boshlandi",
    details: "Tafsilotlar",
    status: "Status",
    name: "Nomi",
    date: "Sana",
    period: "Davr",
  },
  nav: {
    home: "Bosh sahifa",
    sales: "Sotuv",
    marketing: "Marketing",
    chatbot: "Chatbot",
    coach: "Murabbiy",
    settings: "Sozlamalar",
    navigation: "Navigatsiya",
    salesData: "Sotuv ma'lumotlari",
    company: "Kompaniya",
    integration: "Integratsiya",
    analysis: "Tahlil",
    knowledge: "Bilim",
  },
  auth: {
    login: "Kirish",
    loggingIn: "Kirish...",
    username: "Foydalanuvchi",
    password: "Parol",
    usernameRequired: "Foydalanuvchi nomini kiriting",
    passwordMin: "Parol kamida 8 belgi",
    loginError: "Kirishda xato. Qayta urinib ko'ring.",
    showPassword: "Parolni ko'rsatish",
    hidePassword: "Parolni yashirish",
    welcome: "Xush kelibsiz",
    subtitle: "Interwork Marketing platformasiga kiring",
  },
  marketing: {
    module: "Marketing",
    nav: {
      dashboard: "Dashboard",
      campaigns: "Kampaniyalar",
      creatives: "Kreativlar",
      scenarios: "Senariy",
      competitors: "Raqobatchilar",
      stories: "Storylar",
      clients: "Mijozlar",
      summaries: "Xulosalar",
      adAccounts: "Reklama akkauntlari",
    },
    dashboard: {
      title: "Dashboard",
      breadcrumb: "Marketing",
      emptyTitle: "Ma'lumot yo'q",
      emptyDesc: "Tanlangan davr uchun raqamlar mavjud emas. Akkauntni sinxronlang.",
      spend: "Xarajat",
      leads: "Lidlar",
      cpl: "CPL",
      roas: "ROAS",
      impressions: "Ko'rsatishlar",
      clicks: "Bosishlar",
      ctr: "CTR",
      sync: "Sinxronlash",
    },
    campaigns: {
      title: "Kampaniyalar",
      description: "Meta spend + CRM (SalesLead · fb ad tags)",
      searchPlaceholder: "Kampaniya nomi...",
      notFound: "Kampaniya topilmadi",
      notFoundDesc: "Filtrlarni o'zgartiring yoki sinxronizatsiyani kuting",
      noActive: "Faol kampaniya yo'q",
      noActiveDesc: "Hozircha faol kampaniyalar topilmadi",
      activeSection: "Faol kampaniyalar",
      inactiveSection: "To'xtatilgan / arxiv",
      wonDynamics: "Won dynamics — by day",
      campaignsCount: "{{count}} campaigns · Meta spend + CRM",
      col: {
        campaign: "Kampaniya",
        spend: "Spend",
        leads: "Leads",
        cpl: "CPL",
        act: "Act",
        won: "Won",
        lost: "Lost",
        qual: "Qual",
        costWon: "Cost/Won",
        convRate: "Conv.rate",
        qualRate: "Qual.rate",
        dealTime: "Deal time",
      },
      totalRow: "Jami ({{count}} kampaniya)",
      back: "Kampaniyalar",
      overview: "Umumiy",
      creativesTab: "Kreativlar",
      summaryTab: "Xulosa",
    },
    creatives: {
      title: "Kreativlar",
      description: "Reklama kutubxonasi — faol reklamalar, kreativlar va statuslar",
      lastSync: "oxirgi sinxron",
      filters: "Filtrlar",
      results: "~{{count}} natija",
      empty: "Kreativ topilmadi",
      emptyDesc: "Filtr yoki davrni o'zgartiring",
      allCampaigns: "Barcha kampaniyalar",
    },
    competitors: {
      title: "Raqobatchilar",
      description: "Instagram raqobatchilaringiz: benchmark, engagement va AI tahlil",
      add: "Raqobatchi qo'shish",
      addFirst: "Birinchi raqobatchini qo'shing",
      addFirstDesc:
        "Raqobatchining Instagram profilini kiriting — biz benchmark, top reels va AI tahlilni avtomatik tayyorlaymiz.",
      emptyCompare: "Taqqoslash uchun raqobatchi yo'q",
      emptyCompareDesc:
        "Avval raqobatchi qo'shing — keyin u bilan «biz vs raqobatchi» tahlilini ko'rasiz.",
      notConfigured: "Raqobatchilar tahlili sozlanmagan",
      notConfiguredDesc:
        "Instagram ma'lumotlarini yig'ish uchun Apify integratsiyasi ulanmagan. Administrator bilan bog'laning.",
      own: "Bizning akkaunt",
      scrape: "Yangilash",
      deepScrape: "Deep scrape",
      followers: "Obunachilar",
      posts: "Postlar",
      engagement: "Engagement",
      avgViews: "O'rtacha views",
      videoAnalysis: "Video AI tahlil",
      compare: "Taqqoslash",
      username: "Instagram username",
      displayName: "Ko'rinadigan nom",
      isOwn: "Bu bizning akkaunt",
    },
    stories: {
      title: "Story arxivi",
      description: "Instagram storilarini saqlash va ko'rish",
    },
    scenarios: {
      title: "Senariylar",
      description: "AI asosida reklam senariylari",
    },
    clients: {
      title: "Mijozlar",
      description: "SalesCRM mijozlari va bo'limlar",
      search: "Mijoz qidirish...",
      empty: "Mijoz topilmadi",
    },
    summaries: {
      title: "Xulosalar",
      description: "Sotuv AI xulosalari",
    },
    status: {
      ACTIVE: "Faol",
      PAUSED: "To'xtatilgan",
      ARCHIVED: "Arxiv",
      DELETED: "O'chirilgan",
    },
  },
  period: {
    today: "Bugun",
    week: "Hafta",
    month: "Oy",
    overall: "Umumiy",
    custom: "Maxsus",
  },
  legal: {
    privacy: {
      title: "Maxfiylik siyosati",
      lastUpdated: "Yangilangan: 2026-05-07",
    },
    terms: {
      title: "Foydalanish shartlari",
      lastUpdated: "Yangilangan: 2026-05-07",
    },
    deletion: {
      title: "Ma'lumot o'chirish so'rovi",
      description:
        "Bu yerda Meta orqali yig'ilgan ma'lumotlaringizni o'chirish so'rovini yuborishingiz mumkin.",
      submit: "So'rov yuborish",
      success: "So'rov qabul qilindi",
    },
  },
  chatbot: {
    nav: {
      dashboard: "Dashboard",
      inbox: "Inbox",
      analytics: "Analitika",
      leads: "Lidlar",
      knowledge: "Bilim bazasi",
      channels: "Kanallar",
      demo: "Demo rejim",
    },
    dashboard: {
      title: "Chatbot dashboard",
      subtitle: "Real-time chatbot ko'rsatkichlari va lead funnel",
      kpi: {
        activeConversations: "Aktiv suhbatlar",
        avgResponseTime: "O'rtacha javob vaqti",
        conversionRate: "Konversiya darajasi",
        totalLeads: "Jami lidlar",
      },
      sections: {
        funnel: "Reklama → Chat → Lead → Deal funnel",
        recentConversations: "So'nggi suhbatlar",
        aiAcceptRate: "AI takliflari qabul ko'rsatkichi",
        channelBreakdown: "Kanallar bo'yicha",
      },
      empty: "Hali suhbatlar yo'q",
    },
    analytics: {
      title: "Chatbot analitikasi",
      subtitle: "Chuqur tahlil va export",
      filters: { period: "Davr", channel: "Kanal", agent: "Operator" },
      charts: {
        dailyVolume: "Kunlik suhbat hajmi",
        responseTime: "Javob vaqti taqsimoti",
        intentBreakdown: "Intent taqsimoti",
        topFaq: "Eng ko'p FAQ savollar",
        aiHumanRatio: "AI vs operator nisbati",
        leadTimeline: "Lead konversiya dinamikasi",
      },
    },
    leads: {
      title: "Chatbot lidlari",
      subtitle: "Chatbot orqali yaratilgan barcha lidlar",
      columns: {
        contact: "Mijoz",
        intent: "Intent",
        channel: "Kanal",
        amoStatus: "AmoCRM",
        createdAt: "Yaratildi",
        source: "Manba",
      },
      amoStatus: {
        synced: "Sinxron",
        pending: "Kutilmoqda",
        failed: "Xato",
        notSynced: "Sinxron emas",
      },
    },
    funnel: { ad: "Reklama", chat: "Chat", lead: "Lead", deal: "Deal" },
    intent: {
      FAQ: "FAQ",
      BUYER_INTENT: "Sotib olish niyati",
      OBJECTION: "E'tiroz",
      COMPLAINT: "Shikoyat",
      SMALL_TALK: "Suhbat",
      OTHER: "Boshqa",
    },
    demo: {
      title: "Meta App Review demo",
      banner: "Meta Reviewer Demo Mode — English UI",
      steps: {
        connect: "Connect Instagram",
        selectAccount: "Select Business account",
        inbox: "View Inbox (live messages)",
        reply: "Accept AI suggestion + Reply",
        verify: "Verify on Instagram app",
        comments: "Comment management",
      },
      next: "Keyingi qadam",
      done: "Yakunlash",
    },
  },
  errors: {
    generic: "Kutilmagan xatolik",
    network: "Tarmoq xatosi. Qayta urinib ko'ring",
    forbidden: "Ruxsat yo'q",
    notFound: "Topilmadi",
    server: "Server xatosi",
  },
  ai: {
    assistant: "AI yordamchi",
    ask: "Savol bering...",
    thinking: "O'ylayapman...",
  },
  sales: {
    contacts: "Kontaktlar",
    pipelines: "Pipeline'lar",
    deals: "Deal'lar",
    calls: "Qo'ng'iroqlar",
    custdev: "CustDev",
    managers: "Menejerlar",
    leaderboard: "Reyting",
    plans: "Rejalar",
    voronka: "Voronka audit",
    playbook: "Playbook",
    todayCalls: "Bugungi qo'ng'iroqlar",
    activeDeals: "Aktiv deal'lar",
  },
  coach: {
    hub: "Markazi",
    lessons: "Darslar",
    chat: "Suhbat",
    attendance: "Faollik",
    certificates: "Sertifikatlar",
    exam: "Voice Exam",
    examStart: "Imtihon boshlash",
    history: "Tarix",
    scenarios: "Stsenariylar",
    stats: "Statistika",
  },
  settings: {
    general: "Umumiy",
    branding: "Brending",
    integrations: "Integratsiyalar",
    telegram: "Telegram",
    salesCriteria: "Sotuv mezonlari",
    aiCosts: "AI xarajatlar",
  },
};
